/** ISO 3166-1 alpha-2 codes for national teams (football-data.org names). */
const TEAM_ISO: Record<string, string> = {
  'Algeria': 'DZ',
  'Argentina': 'AR',
  'Australia': 'AU',
  'Austria': 'AT',
  'Belgium': 'BE',
  'Bolivia': 'BO',
  'Bosnia-Herzegovina': 'BA',
  'Brazil': 'BR',
  'Cameroon': 'CM',
  'Canada': 'CA',
  'Chile': 'CL',
  'China PR': 'CN',
  'Colombia': 'CO',
  'Costa Rica': 'CR',
  'Croatia': 'HR',
  'Curaçao': 'CW',
  'Czech Republic': 'CZ',
  'Czechia': 'CZ',
  'Denmark': 'DK',
  'Ecuador': 'EC',
  'Egypt': 'EG',
  'England': 'GB',
  'France': 'FR',
  'Germany': 'DE',
  'Ghana': 'GH',
  'Greece': 'GR',
  'Honduras': 'HN',
  'Iran': 'IR',
  'Iraq': 'IQ',
  'Italy': 'IT',
  'Ivory Coast': 'CI',
  "Côte d'Ivoire": 'CI',
  'Jamaica': 'JM',
  'Japan': 'JP',
  'Jordan': 'JO',
  'Korea Republic': 'KR',
  'South Korea': 'KR',
  'Mexico': 'MX',
  'Morocco': 'MA',
  'Netherlands': 'NL',
  'New Zealand': 'NZ',
  'Nigeria': 'NG',
  'Northern Ireland': 'GB',
  'Norway': 'NO',
  'Panama': 'PA',
  'Paraguay': 'PY',
  'Peru': 'PE',
  'Poland': 'PL',
  'Portugal': 'PT',
  'Qatar': 'QA',
  'Romania': 'RO',
  'Russia': 'RU',
  'Saudi Arabia': 'SA',
  'Scotland': 'GB',
  'Senegal': 'SN',
  'Serbia': 'RS',
  'Slovakia': 'SK',
  'Slovenia': 'SI',
  'South Africa': 'ZA',
  'Spain': 'ES',
  'Sweden': 'SE',
  'Switzerland': 'CH',
  'Tunisia': 'TN',
  'Turkey': 'TR',
  'Ukraine': 'UA',
  'United States': 'US',
  'USA': 'US',
  'Uruguay': 'UY',
  'Uzbekistan': 'UZ',
  'Venezuela': 'VE',
  'Wales': 'GB',
};

export function getTeamIsoCode(teamName: string | null | undefined): string | null {
  if (!teamName || teamName === 'TBD') return null;
  return TEAM_ISO[teamName] ?? TEAM_ISO[teamName.trim()] ?? null;
}

/** Flag image URL (emoji flags don't render on Windows). */
export function getTeamFlagUrl(teamName: string | null | undefined, width = 20): string | null {
  const code = getTeamIsoCode(teamName);
  if (!code) return null;
  return `https://flagcdn.com/w${width}/${code.toLowerCase()}.png`;
}
